import { useMemo } from 'react';
import { PAID_FEATURE, useQueryUserPaidList } from './paidFeature';
import { getRelativeTime } from '@/utils';
import { useUserInfo } from './useUser';

export const useVipLeft = (addr: string, enabled: boolean) => {
  const { data: addrInfo } = useUserInfo(addr);

  const { data: mySubscriptions } = useQueryUserPaidList(
    addr,
    !!addrInfo && !!addrInfo.web3_id && addrInfo.is_vip && enabled,
  );

  const vipLeft = useMemo(() => {
    const vipItem = mySubscriptions?.find(x => x.id === PAID_FEATURE.VIP);

    return vipItem?.expired_at ? getRelativeTime(vipItem?.expired_at) : '-';
  }, [mySubscriptions]);

  return vipLeft;
};
